import React, { useContext, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theme';
import t from '@jetshop/intl';
import { Button, TrendLink } from '../../../ui/Button';
import Spinner from '../../../ui/Spinner';
import { useNotification } from '@jetshop/core/components/Notifications';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { useMutation } from '@apollo/react-hooks';
import addMultipleToCartMutation from '../../../Cart/addMultipleToCart.gql';
import { addToCartError } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import ProductToastWrapper from '../ProductToast';
import AddToCartWrapper from '../../../ProductPage/AddToCart/AddToCartWrapper';

const StyledButton = styled('button')`
  height: 50px;
  text-transform: uppercase;
  width: 250px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;

  &:hover {
    text-decoration: none;
    background: #720714;
  }

  &.alternative {
    background: #000;
    &:hover {
      background: #333;
    }
  }

  @media screen and (max-width: 800px) {
    height: 35px;
    width: 100%;
    margin: 0 0;
  }

  &.half {
    @media screen and (max-width: 800px) {
      width: calc(50% - 8px);
    }
  }
  
  svg {
    height: 20px;
    width: auto;
    path {
      stroke: #fff;
      fill: #000;
    }
  }

  ${theme.above.md} {
    height: 40px;
    max-width: none;
  }
`
const StyledButtonLink = styled('a')`
  height: 50px;
  text-transform: uppercase;
  width: 250px;
  font-size: 14px;
  border-radius: 50px;
  margin: 0 auto;
  background: #911827;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  text-decoration: none;
  
  &:hover {
    text-decoration: none;
    background: #720714;
  }

  &.alternative {
    background: #000;
    &:hover {
      background: #333;
    }
  }

  @media screen and (max-width: 800px) {
    height: 35px;
    width: 100%;
    margin: 0 0;
  }

  &.half {
    @media screen and (max-width: 800px) {
      width: calc(50% - 8px);
    }
  }
  
  svg {
    height: 20px;
    width: auto;
    path {
      stroke: #fff;
      fill: #000;
    }
  }

  ${theme.above.md} {
    height: 40px;
    max-width: none;
  }
`

const StyledButtonIcon = styled('div')`
    width: auto;
    height: 20px;
`



export const Main3DButton = (props) => {
  const [addToCartClicked, setAddToCartClicked] = useState(false);
  const [share, setShare] = useState(false)
  const [trigger, dismiss] = useNotification();
  let className = '';
  if (props.alternative) {
    className = 'alternative';
  }
  if (props.halfOnMobile) {
    className += ' half';
  }

  const [wasSuccess, setWasSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { cartId, setCartId } = useContext(CartIdContext);
  const [useAddMultipleToCartMutation] = useMutation(addMultipleToCartMutation);
  const callbackOptions = {};

  const onAddToCartError = (callbackOptions) => {
    setError('Something went wrong adding products to cart. Please try again.');
  };

  const onAddToCartSuccess = (callbackOptions) => {
    setWasSuccess(true);
  };

  const AddToCart = (products) => {
    setAddToCartClicked(false)
    return useAddMultipleToCartMutation({
      variables: {
        cartId: cartId,
        items: products
      },
    });
  };

  const addToCartSuccess = function ({ onAddToCartSuccess, callbackOptions, cartId, setCartId, }) {
    return ({ data }) => {
      if (!cartId || data.addMultipleToCart.cart.id !== cartId) {
        data.addMultipleToCart && setCartId(data.addMultipleToCart.cart.id);
      }
      if (onAddToCartSuccess) {
        onAddToCartSuccess(callbackOptions);
        trigger(
          <ProductToastWrapper
            selectedVariation={props.products.articleNumber}
            product={props.product.productData}
            image={props.product.images[0].url}
            name={props.product.name}
          />,
          {
            id: '3D-' + new Date().getTime(),
            type: 'add-to-cart',
            autoCloseAfter: 2500,
          }
        );
      }
    };
  };

  if (addToCartClicked && props.products) {
    AddToCart([props.products]).then(
      addToCartSuccess({
        onAddToCartSuccess,
        callbackOptions,
        cartId,
        setCartId,
      })
    )
      .catch(addToCartError({ onAddToCartError, callbackOptions }))
  }

  if (props.href) {
    return (
      <>
        <StyledButtonLink
          href={props.href}
          target={'_blank'}
          onClick={props.onClick}
          className={className}
        >
          {props.icon && <StyledButtonIcon>{props.icon}</StyledButtonIcon>}
          <span>{t(props.text)}</span>
        </StyledButtonLink>
      </>
    )
  }

  if (props.products) {
    return (
      <>
        <StyledButton type={'submit'} data-testid={'add-to-cart'} onClick={() => {setAddToCartClicked(true);}} className={className}>
          {props.icon && <StyledButtonIcon>{props.icon}</StyledButtonIcon>}
          <span>{t(props.text)}</span>
        </StyledButton>
      </>
    )
  }

  if (props.share) {
    return (
      <>
        <StyledButton onClick={setShare(true)} className={className}>
        {props.icon && <StyledButtonIcon>{props.icon}</StyledButtonIcon>}
        <span>{t(props.text)}</span>
      </StyledButton>
      </>
      )
  }

  return (
    <>
      <StyledButton onClick={props.onClick} className={className}>
        {props.icon && <StyledButtonIcon>{props.icon}</StyledButtonIcon>}
        <span>{t(props.text)}</span>
      </StyledButton>
    </>
  );
}